import React from "react";
import OnboardingStepsProgress from "../../../components/InstructorDashboardComponents/OnboardingStepsProgress/OnboardingStepsProgress";

const InstructorOnboarding = () => {
  return (
    <div className="bg-white flex flex-col shadow-shadow17 border rounded-xl px-4 md:px-8 lg:px-12 py-4 md:py-8 lg:py-12">
      <OnboardingStepsProgress progress={10} />
    </div>
  );
};

export default InstructorOnboarding;
